import React from "react";

const PrevArrow = (props) =>
{
return(
    <button className="PreArrow"><i className="ri-arrow-left-s-line" onClick={props.onClick}></i></button>
);

}

export default PrevArrow